import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListSurroundingIndustries from "../Components/Surrounding Industries/listSurroundingIndustries";
import AddSurroundingIndustries from "../Components/Surrounding Industries/addSurroundingIndustries";

const SurroundingIndustriesRoutes = () => {
    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
  
    const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
    // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/surrounding_industries" element={<ListSurroundingIndustries></ListSurroundingIndustries>}></Route>
      <Route path="/surrounding_industries/add" element={canAdd ? <AddSurroundingIndustries></AddSurroundingIndustries> : <Navigate to="/surrounding_industries" replace />}></Route>
    </Routes>
  );
};

export default SurroundingIndustriesRoutes;
